import { render, staticRenderFns } from "./CompletedChatsTable.vue?vue&type=template&id=0038fbfc&scoped=true&"
import script from "./CompletedChatsTable.vue?vue&type=script&lang=ts&"
export * from "./CompletedChatsTable.vue?vue&type=script&lang=ts&"
import style0 from "./CompletedChatsTable.vue?vue&type=style&index=0&id=0038fbfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0038fbfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VTooltip})


/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
